var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.399414,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EFF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8994 19.3999L17.8994 14.2099M13.6694 16.9599L22.3994 22.0099L31.1294 16.9599M22.3994 32.0799V21.9999M31.3994 25.9999V17.9999C31.3991 17.6492 31.3065 17.3047 31.131 17.0011C30.9554 16.6974 30.7032 16.4453 30.3994 16.2699L23.3994 12.2699C23.0954 12.0944 22.7505 12.002 22.3994 12.002C22.0483 12.002 21.7035 12.0944 21.3994 12.2699L14.3994 16.2699C14.0957 16.4453 13.8434 16.6974 13.6679 17.0011C13.4924 17.3047 13.3998 17.6492 13.3994 17.9999V25.9999C13.3998 26.3506 13.4924 26.6951 13.6679 26.9987C13.8434 27.3024 14.0957 27.5545 14.3994 27.7299L21.3994 31.7299C21.7035 31.9054 22.0483 31.9979 22.3994 31.9979C22.7505 31.9979 23.0954 31.9054 23.3994 31.7299L30.3994 27.7299C30.7032 27.5545 30.9554 27.3024 31.131 26.9987C31.3065 26.6951 31.3991 26.3506 31.3994 25.9999Z",
    stroke: "#194185",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBoxIcon);
export default __webpack_public_path__ + "b90abcd1def67617d3fd5a86cbbf56a3.svg";
export { ForwardRef as ReactComponent };